@if (filteredQuestionLookups.length) {
    <div class="container-fluid well">
        <h5>{{ title }}</h5>
        @for (questionLookup of filteredQuestionLookups; track questionLookup) {
            <div class="row">
                <div class="col-xs-12">
                    <div class="row">
                        <div
                            style="visibility: hidden;height: 0;"
                            class="control-label"
                            >{{ title }}:
                            {{questionLookup.id}}
                        </div>
                        <div class="col-xs-12">
                            <i
                                class="nlrp-icon nlrp-icon-error error"
                                style="cursor: auto"></i>
                            <span> {{showQuestion(questionLookup.id)}} </span>
                        </div>
                        <div class="col-xs-2">
                            <div class="input-group">
                                @for (option of values; track option; let i = $index) {
                                    <label class="nlr-radio">
                                        @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                            <input
                                                type="radio"
                                                #response="ngModel"
                                                [ngClass]="{'has-radio-error': response | formFieldHasError}"
                                                class="form-control"
                                                name="responses"
                                                [value]="option.value"
                                                [(ngModel)]="responseViewModel[questionLookup.id].response"
                                                (change)="checkValue(questionLookup.id, option.value)"
                                                [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                                required />
                                        }
                                        <span>{{option.displayValue}}</span>
                                    </label>
                                }
                            </div>
                        </div>
                        @if (labelHidden(questionLookup.id)) {
                            <div class="col-xs-10">
                                <i
                                    class="nlrp-icon nlrp-icon-info info"
                                    style="cursor: auto"></i>
                                <span>
                                    {{showLabel(questionLookup.id)}}
                                </span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
}
